<template>
  <ButtonStyle
    v-bind="$attrs"
    variant="secondary"
    :size="size"
    :icon="icon"
    :text="text"
    :iconTone="iconTone"
    :active="active"
    :disabled="disabled"
    :type="type"
  >
    <template v-if="$slots.default" #default>
      <slot />
    </template>
  </ButtonStyle>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import ButtonStyle from "@/elements/UI/button/ButtonStyle/ButtonStyle.vue";

export default defineComponent({
  name: "SecondaryButton",
  inheritAttrs: false,
  components: {ButtonStyle},
  props: {
    size: {
      type: String as PropType<Size>,
      default: "M"
    },
    icon: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    iconTone: {
      type: String as PropType<IconTone>,
      default: "default"
    },
    active: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String as PropType<ButtonTypeClick>,
      default: "button"
    }
  }
});
</script>
